<template>
  <div id="taskResult">
    <ots-main-title :mainTopBtn="mainTopBtnList"></ots-main-title>
    <div class="question-detection-container">
      <div class="testing-process"><strong>检测进度：</strong>已检测 {{this.analysisQuestionCount}} / {{this.allQuestionCount}} 题<font v-if="this.taskExemptCount > 0">，其中免检试题 {{this.taskExemptCount}} 道</font></div>
      <el-tabs v-model="activeTab" type="border-card">
        <el-tab-pane label="检测问题详情" name="ATable">
          <div class="problem-details-container">
            <div class="problem-stats">
              <div class="stats-header">
                <h5>试题问题统计：</h5>
                <div class="tag-group">
                  <el-tag
                    v-for="tag in problemTags"
                    :key="tag.itemId"
                    :type="activeProblemType === tag.itemId ? '' : 'info'"
                    @click="handleProblemTypeChange(tag.itemId)"
                    :class="['problem-tag', { 'is-disabled': tag.count === 0 }]"
                  >
                    {{ tag.itemName }}({{ tag.count }})
                  </el-tag>
                </div>
              </div>
            </div>

            <!-- 试题表格部分 -->
            <div>
              <el-table
                ref="problemTable"
                :data="tableDataA"
                style="width: 100%"
                row-key="id"
                :empty-text="emptyTextA"
                @expand-change="handleExpandChangeA">

                <!-- 序号列 -->
                <el-table-column
                  label="序号"
                  prop="questionNumber"
                  width="80">
                </el-table-column>

                <!-- 题干列（支持复合题层级缩进） -->
                <el-table-column
                  label="题干"
                  prop="title">
                  <template slot-scope="scope">
                    <div :style="{ 'font-weight': scope.row.haveSubQuestion ? 'bold' : 'normal' }">
                      <font style="color: red;">[{{ scope.row.typeName }}] </font>{{ scope.row.title }}
                      <span v-if="scope.row.haveSubQuestion" style="color: #909399; font-size: 12px;">
                        （共 {{ scope.row.questionSubList ? scope.row.questionSubList.length : 0 }} 子题）
                      </span>
                    </div>
                  </template>
                </el-table-column>

                <!-- 操作列 -->
                <el-table-column
                  label="操作"
                  width="120"
                  align="right">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      @click="toggleRowExpansionA(scope.$index, scope.row)">
                      {{ expandedRowsA.includes(scope.row.id) ? '收起' : '展开' }}
                    </el-button>
                  </template>
                </el-table-column>

                <!-- 展开行内容 -->
                <el-table-column type="expand" width="0">
                  <template slot-scope="props">
                    <div class="expand-content">
                      <template v-if="props.row.haveSubQuestion">
                        <div v-for="(child, index) in props.row.questionSubList" :key="child.id" class="child-question">
                          <p><strong>子题{{ index + 1 }}</strong>：{{ child.title }}</p>
                          <p><strong>选项</strong>：{{ child.options }}</p>
                          <p><strong>正确答案</strong>：{{ child.answer }}</p>
                          <p><strong>知识点</strong>：{{ child.knowledge }}</p>
                          <p><strong>难度</strong>：{{ formatDifficulty(child.difficulty) }}</p>
                          <p><strong>解析</strong>：{{ child.analysis }}</p>
                          <el-divider v-if="index < props.row.questionSubList.length - 1"></el-divider>
                        </div>
                      </template>
                      <template v-else>
                        <p><strong>选项</strong>：{{ props.row.options }}</p>
                        <p><strong>正确答案</strong>：{{ props.row.answer }}</p>
                        <p><strong>知识点</strong>：{{ props.row.knowledge }}</p>
                        <p><strong>难度</strong>：{{ formatDifficulty(props.row.difficulty) }}</p>
                        <p><strong>解析</strong>：{{ props.row.analysis }}</p>
                      </template>
                      <div class="detection-results">
                        <p class="detection-title"><strong><font class="detection-title-title">检测结果</font></strong>：</p>
                        <div v-for="(result, index) in props.row.questionResultList" :key="index" class="detection-item">
                          <p><b><font style="color: green;">{{ result.itemName }}</font>：</b>{{ result.detecteResult }}</p>
                        </div>
                      </div>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
              <ots-pagination :pagination="paginationA" @changeNum="changeSizeA" @changePage="changePageA"></ots-pagination>
            </div>
          </div>
        </el-tab-pane>

        <el-tab-pane label="试题重复检测" name="BTable">
          <div class="tableDivPadding">
              <ots-table :tableHeader="tableHeaderB" :tableData="tableDataB" :empty-text="emptyTextB"></ots-table>
              <ots-pagination :pagination="paginationB" @changeNum="changeSizeB" @changePage="changePageB"></ots-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="试题知识点" name="CTable">
          <div class="tableDivPadding">
              <ots-table :tableHeader="tableHeaderC" :tableData="tableDataC" :empty-text="emptyTextC"></ots-table>
              <ots-pagination :pagination="paginationC" @changeNum="changeSizeC" @changePage="changePageC"></ots-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="试题解析" name="DTable">
          <div style="padding:0px 10px 10px 10px;">
            <el-table
              ref="analysisTable"
              :data="tableDataD"
              style="width: 100%; margin-top:10px;"
              row-key="id"
              :empty-text="emptyTextD"
              @expand-change="handleExpandChangeD">

              <!-- 序号列 -->
              <el-table-column
                label="序号"
                prop="questionNumber"
                width="80">
              </el-table-column>

              <!-- 题干列（支持复合题层级缩进） -->
              <el-table-column
                label="题干"
                prop="title">
                <template slot-scope="scope">
                  <div :style="{ 'font-weight': scope.row.haveSubQuestion ? 'bold' : 'normal' }">
                    <font style="color: red;">[{{ scope.row.typeName }}] </font>{{ scope.row.title }}
                    <span v-if="scope.row.haveSubQuestion" style="color: #909399; font-size: 12px;">
                      （共 {{ scope.row.questionSubList ? scope.row.questionSubList.length : 0 }} 子题）
                    </span>
                  </div>
                </template>
              </el-table-column>

              <!-- 操作列 -->
              <el-table-column
                label="操作"
                width="120"
                align="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="toggleRowExpansionD(scope.$index, scope.row)">
                    {{ expandedRowsD.includes(scope.row.id) ? '收起' : '展开' }}
                  </el-button>
                </template>
              </el-table-column>

              <!-- 展开行内容 -->
              <el-table-column type="expand" width="0">
                <template slot-scope="props">
                  <div class="expand-content">
                    <template v-if="props.row.haveSubQuestion">
                      <div v-for="(child, index) in props.row.questionSubList" :key="child.id" class="child-question">
                        <p><strong>子题{{ index + 1 }}</strong>：{{ child.title }}</p>
                        <p><strong>选项</strong>：{{ child.options }}</p>
                        <p><strong>正确答案</strong>：{{ child.answer }}</p>
                        <p><strong>知识点</strong>：{{ child.knowledge }}</p>
                        <p><strong>难度</strong>：{{ formatDifficulty(child.difficulty) }}</p>
                        <p><strong>解析</strong>：{{ child.analysis }}</p>
                        <el-divider v-if="index < props.row.questionSubList.length - 1"></el-divider>
                      </div>
                    </template>
                    <template v-else>
                      <p><strong>选项</strong>：{{ props.row.options }}</p>
                      <p><strong>正确答案</strong>：{{ props.row.answer }}</p>
                      <p><strong>知识点</strong>：{{ props.row.knowledge }}</p>
                      <p><strong>难度</strong>：{{ formatDifficulty(props.row.difficulty) }}</p>
                      <p><strong>解析</strong>：{{ props.row.analysis }}</p>
                    </template>
                    <div class="detection-results">
                      <p class="detection-title"><strong><font class="detection-title-title">检测结果</font></strong>：</p>
                      <div v-for="(result, index) in props.row.questionResultList" :key="index" class="detection-item">
                        <p><b><font style="color: green;">{{ result.itemName }}</font>：</b>{{ result.detecteResult }}</p>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <ots-pagination :pagination="paginationD" @changeNum="changeSizeD" @changePage="changePageD"></ots-pagination>
          </div>
        </el-tab-pane>

        <el-tab-pane label="试题难度" name="ETable">
          <div style="padding:0px 10px 10px 10px;">
            <el-table
              ref="hardTable"
              :data="tableDataE"
              style="width: 100%; margin-top:10px;"
              row-key="id"
              :empty-text="emptyTextE"
              @expand-change="handleExpandChangeE">

              <!-- 序号列 -->
              <el-table-column
                label="序号"
                prop="questionNumber"
                width="80">
              </el-table-column>

              <!-- 题干列（支持复合题层级缩进） -->
              <el-table-column
                label="题干"
                prop="title">
                <template slot-scope="scope">
                  <div :style="{ 'font-weight': scope.row.haveSubQuestion ? 'bold' : 'normal' }">
                    <font style="color: red;">[{{ scope.row.typeName }}] </font>{{ scope.row.title }}
                    <span v-if="scope.row.haveSubQuestion" style="color: #909399; font-size: 12px;">
                      （共 {{ scope.row.questionSubList ? scope.row.questionSubList.length : 0 }} 子题）
                    </span>
                  </div>
                </template>
              </el-table-column>

              <!-- 操作列 -->
              <el-table-column
                label="操作"
                width="120"
                align="right">
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="toggleRowExpansionE(scope.$index, scope.row)">
                    {{ expandedRowsE.includes(scope.row.id) ? '收起' : '展开' }}
                  </el-button>
                </template>
              </el-table-column>

              <!-- 展开行内容 -->
              <el-table-column type="expand" width="0">
                <template slot-scope="props">
                  <div class="expand-content">
                    <template v-if="props.row.haveSubQuestion">
                      <div v-for="(child, index) in props.row.questionSubList" :key="child.id" class="child-question">
                        <p><strong>子题{{ index + 1 }}</strong>：{{ child.title }}</p>
                        <p><strong>选项</strong>：{{ child.options }}</p>
                        <p><strong>正确答案</strong>：{{ child.answer }}</p>
                        <p><strong>知识点</strong>：{{ child.knowledge }}</p>
                        <p><strong>难度</strong>：{{ formatDifficulty(child.difficulty) }}</p>
                        <p><strong>解析</strong>：{{ child.analysis }}</p>
                        <el-divider v-if="index < props.row.questionSubList.length - 1"></el-divider>
                      </div>
                    </template>
                    <template v-else>
                      <p><strong>选项</strong>：{{ props.row.options }}</p>
                      <p><strong>正确答案</strong>：{{ props.row.answer }}</p>
                      <p><strong>知识点</strong>：{{ props.row.knowledge }}</p>
                      <p><strong>难度</strong>：{{ formatDifficulty(props.row.difficulty) }}</p>
                      <p><strong>解析</strong>：{{ props.row.analysis }}</p>
                    </template>
                    <div class="detection-results">
                      <p class="detection-title"><strong><font class="detection-title-title">检测结果</font></strong>：</p>
                      <div v-for="(result, index) in props.row.questionResultList" :key="index" class="detection-item">
                        <p><b><font style="color: green;">{{ result.itemName }}</font>：</b>{{ result.detecteResult }}</p>
                      </div>
                    </div>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <ots-pagination :pagination="paginationE" @changeNum="changeSizeE" @changePage="changePageE"></ots-pagination>
          </div>
        </el-tab-pane>

      </el-tabs>
      <div class="bottomTips">【温馨提醒】本平台试题检测结果基于AI技术生成，仅供参考，您需自行承担使用风险并建议人工复核，本平台不对结果准确性及衍生后果负责。</div>
    </div>
  </div>
</template>

<script>
import {
  getTaskItemApi,
  getTaskByIdApi,
  getTaskItemUnokCountApi,
  getTaskDetecteInfoApi,
  getTaskDetecteDescriptionApi
} from "@/http/modules/dataV";

export default {
  data() {
    return {
      analysisQuestionCount: 0,
      allQuestionCount: 0,
      taskExemptCount: 0,
      allItemIds: [],

      mainTopBtnList: [
        {
          title: "返回",
          fn: this.goBackPage,
        },
      ],

      activeTab: 'ATable',        // 当前激活的标签页
      activeProblemType: 'all',   // 当前激活的问题类型
      expandedRowsA: [],          // 记录已展开的行ID
      expandedRowsD: [],          // 记录已展开的行ID
      expandedRowsE: [],          // 记录已展开的行ID

      // 问题类型标签
      problemTags: [],

      // 第一个标签页的数据和分页
      tableDataA: [],

      paginationA: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

      // 第二个标签页的数据
      tableHeaderB: [
        {
          title: "题号（重复位置）",
          prop: "detecteResult",
          width: "200",
        },
        {
          title: "重复类型",
          prop: "detecteRemark",
          type: "Left_TableHeader"
        },
      ],
      tableDataB: [],
      paginationB: {
        total: 0
      },
      tableParamsB: {
        itemFirst : "B",
        page: 1,
        size: 10
      },
      // 第三个标签页的数据
      tableHeaderC: [
        {
          title: "题号",
          prop: "questionNumber",
          width: "200"
        },
        {
          title: "建议知识点",
          prop: "detecteResult",
          type: "Left_TableHeader"
        }
      ],
      tableDataC: [],
      paginationC: {
        total: 0
      },
      tableParamsC: {
        itemFirst : "C",
        page: 1,
        size: 10
      },

      // 第四个标签页的数据和分页
      tableDataD: [],

      paginationD: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

      // 第五个标签页的数据和分页
      tableDataE: [],

      paginationE: {
        currentPage: 1,
        pageSize: 10,
        total: 0,
      },

      emptyTextA: "",
      emptyTextB: "",
      emptyTextC: "",
      emptyTextD: "",
      emptyTextE: "",
    }
  },
  created() {
    this.getTaskItem();
    this.getTaskById();
    this.loadProblemTags();
    this.tableListA("all");
    this.tableListB();
    this.tableListC();
    this.tableListD();
    this.tableListE();
  },
  methods: {
    goBackPage(){
      this.$router.go(-1);
    },
    // 获取当前任务都有那些检测项
    async getTaskItem(){
      let resultData = await getTaskItemApi({taskId: this.$route.query.id});
      if (resultData.code == 1) {
        this.allItemIds = resultData.data.map(item => item.itemId);
      }
    },
    // 获取任务数量
    async getTaskById(){
      let resultData = await getTaskByIdApi({taskId: this.$route.query.id});
      if (resultData.code == 1) {
        this.analysisQuestionCount = resultData.data.taskFinishCount
        this.allQuestionCount = resultData.data.taskTotalCount
        this.taskExemptCount = resultData.data.taskExemptCount
      }
    },
    // 问题类型切换
    handleProblemTypeChange(itemId) {
      this.activeProblemType = itemId;
      this.tableListA(itemId);
    },

    // 加载第一个标签的子检测项
    async loadProblemTags(){
      let resultData = await getTaskItemUnokCountApi({taskId: this.$route.query.id});
      if (resultData.code == 1) {
        this.problemTags = resultData.data.data
      }
    },

    // 加载第一个标签页的数据
    async tableListA(tagId) {
      let params = Object.assign(
        {},
        {taskId: this.$route.query.id},
        {itemFirst: "A"},
        {itemSecond: tagId== 'all' ? '' : tagId},
        {page: this.paginationA.currentPage, size: this.paginationA.pageSize}
      )
      let resultData = await getTaskDetecteInfoApi(params);
      if (resultData.code == 1) {
        this.tableDataA = resultData.data.records;
        this.paginationA.total = resultData.data.total;
        if(resultData.data.total == 0){
          this.emptyTextA = "本次检测未发现问题"
        }
      }
    },

    // 第一个标签页的分页方法
    changeSizeA(val) {
      this.paginationA.pageSize = val;
      let itemId = this.activeProblemType=="all"?'':this.activeProblemType;
      this.tableListA(itemId);
    },
    changePageA(val) {
      this.paginationA.currentPage = val;
      let itemId = this.activeProblemType=="all"?'':this.activeProblemType;
      this.tableListA(itemId);
    },

    // 表格展开行变化
    handleExpandChangeA(row, expandedRowsA) {
      if (expandedRowsA.some(item => item.id === row.id)) {
        this.expandedRowsA.push(row.id);
      } else {
        this.expandedRowsA = this.expandedRowsA.filter(id => id !== row.id);
      }
    },

    // 切换行展开状态
    toggleRowExpansionA(index, row) {
      this.$refs.problemTable.toggleRowExpansion(row);
    },

    // 试题重复检测
    async tableListB () {
      let params = Object.assign({},{taskId:this.$route.query.id},this.tableParamsB)
      let resultData = await getTaskDetecteDescriptionApi(params);
      if(resultData.code == 1){
        let resultInfo = resultData.data;
        this.tableDataB = resultInfo.records;
        this.paginationB.total = resultInfo.total;
        if(!this.allItemIds.includes('5')){
          this.emptyTextB = "本次该项未检测"
        }else{
          if(resultInfo.total == 0){
            this.emptyTextB = "本次检测未发现问题"
          }
        }
      }
    },
    changeSizeB(num) {
        this.tableParamsB.size=num
        this.tableListB()
    },
    changePageB(p) {
        this.tableParamsB.page=p
        this.tableListB()
    },
    // 试题知识点
    async tableListC () {
      let params = Object.assign({},{taskId:this.$route.query.id},this.tableParamsC)
      let resultData = await getTaskDetecteDescriptionApi(params);
      if(resultData.code == 1){
        let resultInfo = resultData.data;
        this.tableDataC = resultInfo.records;
        this.paginationC.total = resultInfo.total;
        if(!this.allItemIds.includes('6')){
          this.emptyTextC = "本次该项未检测"
        }else{
          if(resultInfo.total == 0){
            this.emptyTextC = "本次检测未发现问题"
          }
        }
      }
    },
    changeSizeC(num) {
        this.tableParamsC.size=num
        this.tableListC()
    },
    changePageC(p) {
        this.tableParamsC.page=p
        this.tableListC()
    },
    formatDifficulty(level) {
      const map = {
        1: '容易',
        2: '较易',
        3: '中等',
        4: '较难',
        5: '困难'
      };
      return map[level] || '未知难度';
    },

    // 加载第四个标签页的数据
    async tableListD() {
      let params = Object.assign(
        {},
        {taskId: this.$route.query.id},
        {itemFirst: "D"},
        {itemSecond: ""},
        {page: this.paginationD.currentPage, size: this.paginationD.pageSize}
      )
      let resultData = await getTaskDetecteInfoApi(params);
      if (resultData.code == 1) {
        this.tableDataD = resultData.data.records;
        this.paginationD.total = resultData.data.total;
        if(!this.allItemIds.includes('7')){
          this.emptyTextD = "本次该项未检测"
        }else{
          if(resultData.data.total == 0){
            this.emptyTextD = "本次检测未发现问题"
          }
        }
      }
    },

    // 第四个标签页的分页方法
    changeSizeD(val) {
      this.paginationD.pageSize = val;
      this.tableListD();
    },
    changePageD(val) {
      this.paginationD.currentPage = val;
      this.tableListD();
    },

    // 表格展开行变化
    handleExpandChangeD(row, expandedRowsD) {
      if (expandedRowsD.some(item => item.id === row.id)) {
        this.expandedRowsD.push(row.id);
      } else {
        this.expandedRowsD = this.expandedRowsD.filter(id => id !== row.id);
      }
    },

    // 切换行展开状态
    toggleRowExpansionD(index, row) {
      this.$refs.analysisTable.toggleRowExpansion(row);
    },

    // 加载第五个标签页的数据
    async tableListE() {
      let params = Object.assign(
        {},
        {taskId: this.$route.query.id},
        {itemFirst: "E"},
        {itemSecond: ""},
        {page: this.paginationE.currentPage, size: this.paginationE.pageSize}
      )
      let resultData = await getTaskDetecteInfoApi(params);
      if (resultData.code == 1) {
        this.tableDataE = resultData.data.records;
        this.paginationE.total = resultData.data.total;
        if(!this.allItemIds.includes('8')){
          this.emptyTextE = "本次该项未检测"
        }else{
          if(resultData.data.total == 0){
            this.emptyTextE = "本次检测未发现问题"
          }
        }
      }
    },

    // 第五个标签页的分页方法
    changeSizeE(val) {
      this.paginationE.pageSize = val;
      this.tableListE();
    },
    changePageE(val) {
      this.paginationE.currentPage = val;
      this.tableListE();
    },

    // 表格展开行变化
    handleExpandChangeE(row, expandedRowsE) {
      if (expandedRowsE.some(item => item.id === row.id)) {
        this.expandedRowsE.push(row.id);
      } else {
        this.expandedRowsE = this.expandedRowsE.filter(id => id !== row.id);
      }
    },

    // 切换行展开状态
    toggleRowExpansionE(index, row) {
      this.$refs.hardTable.toggleRowExpansion(row);
    },
  }
}
</script>

<style lang="less" scoped>
.question-detection-container {
  margin-top: 16px;
  padding: 24px;
  background: #fff;
  border-radius: 8px;
}

.testing-process{
  font-size: 15px;
  margin: 0px 0px 15px 5px;
}

.problem-details-container {
  padding: 0px 10px 10px 10px;
}

.problem-stats {
  margin-bottom: 20px;

  .stats-header {
    display: flex;
    align-items: center;
    gap: 15px;
    h5 {
      margin: 0;
      font-size: 15px;
      white-space: nowrap;
    }

    .tag-group {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
    }
  }
}

.problem-tag {
  cursor: pointer;
  padding: 0 15px;
  height: 32px;
  line-height: 32px;
  font-size: 14px;
  transition: all 0.3s;
}

.problem-tag:hover {
  opacity: 0.8;
}

.expand-content {
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.expand-content p {
  margin: 0px 0;
  line-height: 30px;
}

.tableDivPadding {
  padding: 10px;
}
.problem-tag.is-disabled {
  opacity: 0.6;
  cursor: not-allowed;
  pointer-events: none;
}
.child-question {
  margin: 10px 0;
  padding-left: 10px;
  border-left: 2px solid #e6e6e6;
}

.detection-results {
  margin-top: 15px;
  border-top: 1px solid #ebeef5;
  padding-top: 10px;
}

.detection-title {
  font-size: 14px;
  color: #606266;
  margin-bottom: 8px;
}

.detection-item {
  margin-left: 20px;
  padding: 5px 0;
}

.detection-item p {
  margin: 0;
  color: #606266;
}

.expand-content strong {
  display: inline-block;
  width: 58px;
  text-align: justify;
  text-align-last: justify;
}

.detection-title-title{
  color:mediumblue;
}
.bottomTips{
  margin-top:10px;
  color:#606266;
}
</style>